import * as actionTypes from "auth/authActionTypes";

export const authError = error => ({ type: actionTypes.AUTH_ERROR, error });
export const authRedirect = () => ({ type: actionTypes.AUTH_REDIRECT });
export const logIn = (redirectPath, oAuthCode) => ({
  type: actionTypes.LOG_IN,
  redirectPath,
  oAuthCode,
});
export const setUser = (user, redirectPath) => ({
  type: actionTypes.SET_USER,
  user,
  redirectPath,
});
export const logOut = () => ({ type: actionTypes.LOG_OUT });
export const deleteUser = () => ({ type: actionTypes.DELETE_USER });
export const setCurrentOrganization = ({ organization, userId }) => ({
  type: actionTypes.SET_CURRENT_ORGANIZATION,
  organization,
  userId,
});
